"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _config = require("@trs/config");
var _styledComponents = require("styled-components");
var R = _interopRequireWildcard(require("ramda"));
var _ShareDetail = _interopRequireDefault(require("./ShareDetail.style"));
var _Doughnut = _interopRequireDefault(require("../charts/doughnut/Doughnut"));
var _ShareDetailLegend = _interopRequireDefault(require("./ShareDetailLegend"));
var _misc = require("../misc");
var _currency = _interopRequireDefault(require("../currency"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var ShareDetail = function ShareDetail(_ref) {
  var name = _ref.name,
    sharePrice = _ref.sharePrice,
    shareData = _ref.shareData,
    priceLabelContent = _ref.priceLabelContent,
    isTimeVisible = _ref.isTimeVisible,
    provider = _ref.provider,
    label = _ref.label,
    theme = _ref.theme,
    employeeCurrency = _ref.employeeCurrency,
    showVested = _ref.showVested,
    showUnvested = _ref.showUnvested;
  return /*#__PURE__*/_react["default"].createElement(_ShareDetail["default"], {
    className: "share-detail-wrapper"
  }, name && /*#__PURE__*/_react["default"].createElement(_misc.Paragraph, {
    className: "container-title"
  }, name), (showUnvested || showVested) && /*#__PURE__*/_react["default"].createElement("div", {
    className: "share-price"
  }, /*#__PURE__*/_react["default"].createElement(_currency["default"], {
    decimals: _config.MAX_DECIMALS,
    currency: R.prop('currency', sharePrice),
    shouldParseFloat: true
  }, R.prop('value', sharePrice)), /*#__PURE__*/_react["default"].createElement("span", null, " / ".concat(label.SHARES_PAGE_GROUP_SINGULAR.toLowerCase()))), isTimeVisible && (showVested || showUnvested) && /*#__PURE__*/_react["default"].createElement("div", {
    key: "last-update",
    className: "last-update"
  }, priceLabelContent), /*#__PURE__*/_react["default"].createElement("section", {
    className: "share-detail__info"
  }, /*#__PURE__*/_react["default"].createElement(_Doughnut["default"], {
    data: shareData,
    labelKey: "shareStatus",
    colors: R.path(['extra', 'sharesColorMap'], theme),
    onItemClick: function onItemClick() {},
    height: 220
  }), /*#__PURE__*/_react["default"].createElement(_ShareDetailLegend["default"], {
    shareData: shareData,
    label: label,
    employeeCurrency: employeeCurrency,
    showVested: showVested,
    showUnvested: showUnvested
  })), /*#__PURE__*/_react["default"].createElement("p", {
    key: "share-detail__caption",
    className: "share-detail__caption"
  }, label.SHARES_PROVIDER_CAPTION.split('%').map(function (item, index) {
    return index % 2 !== 0 ? /*#__PURE__*/_react["default"].createElement("a", {
      key: "".concat(R.prop('name', provider)),
      target: "_blank",
      href: R.prop('url', provider),
      rel: "noreferrer noopener"
    }, R.prop('name', provider)) : item;
  })));
};
ShareDetail.propTypes = {
  /** The app theme */
  theme: _propTypes["default"].shape({}).isRequired,
  /** The name of the share */
  name: _propTypes["default"].string.isRequired,
  /** Information about the share */
  shareData: _propTypes["default"].arrayOf(_propTypes["default"].shape({})).isRequired,
  /** Information about price per share */
  sharePrice: _propTypes["default"].shape({}).isRequired,
  priceLabelContent: _propTypes["default"].node,
  isTimeVisible: _propTypes["default"].bool,
  /** Share type provider */
  provider: _propTypes["default"].shape({}).isRequired,
  label: _propTypes["default"].shape({
    SHARES_PAGE_GROUP_SINGULAR: _propTypes["default"].string,
    SHARES_PROVIDER_CAPTION: _propTypes["default"].string
  }).isRequired,
  employeeCurrency: _propTypes["default"].string.isRequired,
  showVested: _propTypes["default"].bool,
  showUnvested: _propTypes["default"].bool
};
ShareDetail.defaultProps = {
  isTimeVisible: false,
  priceLabelContent: {},
  showVested: true,
  showUnvested: true
};
var _default = exports["default"] = (0, _styledComponents.withTheme)(ShareDetail);